import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import '../styles/EmployeeMaster.css';
import UserTable from '../components/UserTable';
import EmployeeHeader from '../components/EmployeeHeader';
import useAuth from '../pages/useAuth';
const Users = () => {
     useAuth();
     const [employees, setEmployees] = useState([]);
     const navigate = useNavigate();
     const location = useLocation();



     const handleAddClick = () => {

          navigate('/users/add');
     };

     const handleCloseModal = () => {
          navigate('/users');
     };
     const [currentEmployee, setCurrentEmployee] = useState({
          photo: 'https://randomuser.me/api/portraits/men/32.jpg',
          name: '',
          id: '',
          role: ''
     });

     const [showPopup, setShowPopup] = useState(false);

     const popupRef = useRef(null);
     const buttonRef = useRef(null);

     useEffect(() => {
          const userCode = sessionStorage.getItem('user_code');
          const userName = sessionStorage.getItem('user_name');
          const userRole = sessionStorage.getItem('user_role');
          setCurrentEmployee((prev) => ({
               ...prev,
               name: userName,
               id: userCode,
               role: userRole || 'User'
          }));
     }, []);

     return (
          <>
               {/* <EmployeeHeader
        currentEmployee={currentEmployee}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        popupRef={popupRef}
        buttonRef={buttonRef}
      /> */}
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>User Master</h2>
                         <button className="add-employee-btn" onClick={handleAddClick}>
                              Add User
                         </button>
                    </div>

                    <UserTable />
               </div>
          </>
     );
};

export default Users;